import { generatePolygonsParams } from '../redux/dataLayers.map';
import { IAverageIncome } from '../types/dataLayers.types';

export const buildIncomePolygonPayload = (
  incomePoligon: IAverageIncome
): generatePolygonsParams => {
  const coordinates = incomePoligon.geometry[0].map(
    (coordinate: [number, number]) =>
      new google.maps.LatLng(coordinate[1], coordinate[0])
  );

  const fillColor = incomePoligon.color;

  const borderColor = '#000';

  const polygonType = 'averageIncome';

  const poligonStyles = {
    fillColor: fillColor,
    fillOpacity: 0.5,
    strokeColor: borderColor,
    strokeOpacity: 1,
    strokeWeight: 1,
  };

  const clickedPoligonStyles = {
    fillColor: '#383939',
    fillOpacity: 0.5,
    strokeColor: borderColor,
    strokeOpacity: 1,
    strokeWeight: 1,
  };

  return {
    coordinates,
    color: fillColor,
    borderColor,
    polygonType,
    poligonStyles,
    clickedPoligonStyles,
  };
};
